import { LogoutOutlined } from "@ant-design/icons";
import { Button, Flex } from "antd";
import dayjs from "dayjs";
import { displayDateFormat } from "tm-shared/constants";

import { APP_VERSION } from "@/config";
import {
    useAppDispatch,
    useAppSelector,
    useAsyncAction,
    useMultiTap,
} from "@/hooks";
import { logoutService } from "@/Services/Logout";
import { BaseButton, SecondaryText } from "@/shared/ui";
import { saveProgressToServerThunk } from "@/store/thunks";

interface ProfileActionsBlockProps {
    onOpenCameraMode: () => void;
}

export const ProfileActionsBlock = ({
    onOpenCameraMode,
}: ProfileActionsBlockProps) => {
    const dispatch = useAppDispatch();
    const userId = useAppSelector((s) => s.user.id);
    const lastSyncedAt = useAppSelector(
        (state) => state.offline.progress.lastSyncedAt,
    );

    const lastSyncDate = lastSyncedAt ? dayjs(lastSyncedAt) : null;
    const lastSyncDisplay = lastSyncDate
        ? dayjs().isSame(lastSyncDate, "day")
            ? lastSyncDate.format(displayDateFormat.time)
            : lastSyncDate.format(displayDateFormat.dateTime)
        : null;

    const [logoutHandler, logoutLoading] = useAsyncAction(async () => {
        localStorage.setItem("prevUserId", userId);

        try {
            await dispatch(saveProgressToServerThunk()).unwrap();
        } catch (error) {
            console.error(error);
        }

        await logoutService();
    });

    const handleOpenChangeCameraModal = useMultiTap(
        () => {
            onOpenCameraMode();
        },
        {
            taps: 3,
        },
    );

    return (
        <Flex vertical gap={8}>
            <Button
                type="text"
                style={{ width: "fit-content", alignSelf: "center" }}
                onClick={handleOpenChangeCameraModal}
            >
                <SecondaryText>v{APP_VERSION}</SecondaryText>
            </Button>

            <BaseButton
                type="primary"
                htmlType="submit"
                icon={<LogoutOutlined />}
                onClick={logoutHandler}
                loading={logoutLoading}
            >
                Вийти
            </BaseButton>

            {lastSyncDisplay && (
                <SecondaryText>
                    Остання синхронізація: {lastSyncDisplay}
                </SecondaryText>
            )}
        </Flex>
    );
};
